import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AdminDashboardFunnel, AdminDashboardSectionState } from "@/types/dashboard";

export type DashboardFunnelState = AdminDashboardSectionState<AdminDashboardFunnel>;

export const dashboardFunnelInitialState: DashboardFunnelState = {
  data: null,
  error: null,
};

const slice = createSlice({
  name: "dashboardFunnel",
  initialState: dashboardFunnelInitialState,
  reducers: {
    setDashboardFunnelAction(state, { payload }: PayloadAction<AdminDashboardFunnel | null>) {
      state.data = payload;
      state.error = null;
    },
    setDashboardFunnelErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload;
    },
  },
});

export const { setDashboardFunnelAction, setDashboardFunnelErrorAction } = slice.actions;
export default slice.reducer;
